import { useState } from "react";
import ModalComponent from "@zenith/components/ui/ModalComponent/modal-component/modal-component";
import ContactSupportModal from "@zenith/pages/SendMoneyPage/components/ContactSupportModal";

export const RISK_BLOCKED_TITLE = "We couldn't complete this request";
export const RISK_BLOCKED_BODY =
  "For your security, we couldn't complete this request. Kindly contact our support team for help.";
export const RISK_BLOCKED_CONTACT_SUPPORT = "Contact support";

interface RiskBlockedModalProps {
  open: boolean;
  /** Called once the user is done with the modal, from either the modal or the support details. */
  onClose: () => void;
}

/**
 * Shown when our fraud checks refuse a transfer, refund or credential change outright. Trying again
 * cannot change the outcome, so the user is pointed to support rather than back to the form.
 */
const RiskBlockedModal = ({ open, onClose }: RiskBlockedModalProps) => {
  const [showSupport, setShowSupport] = useState(false);

  const close = () => {
    setShowSupport(false);
    onClose();
  };

  return (
    <>
      <ModalComponent
        showModal={open && !showSupport}
        title={RISK_BLOCKED_TITLE}
        body={RISK_BLOCKED_BODY}
        buttonText={RISK_BLOCKED_CONTACT_SUPPORT}
        onClickButton={() => setShowSupport(true)}
        onClickClose={close}
      />
      <ContactSupportModal open={open && showSupport} onClose={close} />
    </>
  );
};

export default RiskBlockedModal;
